import { ref } from 'vue';
import { v4 as createUUID } from 'uuid';
import { useCommonStore } from '@stores';

//
const KAKAO_STATE = '___kakaoState___';

export const useKakao = () => {
  const commonStore = useCommonStore();
  const clientId = import.meta.env.VITE_APP_OAUTH_KAKAO_CLIENT_ID;
  const redirectUri = `${window.location.origin}/auth/callback-kakao`;

  const state = ref(commonStore.getSessionStorage(KAKAO_STATE));
  if (!state.value) {
    state.value = createUUID();
    commonStore.setStorage('sessionStorage', KAKAO_STATE, state.value);
  }

  const requestAuthUrl = `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state.value}&through_account=false`;

  return {
    requestAuthUrl,
    state,
    redirectUri,
    KAKAO_STATE,
  };
};
